import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { gecersizMailler, mailListesiDuzenle } from "../../../helpers/mailListesi";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SabitGelirService, donemAdi, sabitGelirTurAdi } from "../../../services/SabitGelirService";
import { storeActivityIndicator, storeEbbeModalCallback } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { AddAmbarRequest } from "../../../models/request/ambar/AddAmbarRequest";
import { AmbarService } from "../../../services/AmbarService";
import { AddAmbarResponse } from "../../../models/response/ambar/AddAmbarResponse";
import { GetAmbarByIdResponseOvertimePersonnel, GetAmbarByIdResponsePorteragePersonnel, GetAmbarByIdResponse, GetAmbarByIdResponseAmbarExpectedIncomeOutcome, GetAmbarByIdResponseAmbarProduct, GetAmbarByIdResponseFileArchive } from "../../../models/response/ambar/GetAmbarByIdResponse";
import SiparisTuruSecici from "../../../components/SiparisTuruSecici";
import PageHeader from "../../../components/PageHeader";
import GeneralInformation from "./Components/GeneralInformation";
import { ConstantService } from "../../../services/ConstantService";
import VoyageInformation from "./Components/VoyageInformation";
import moment from "moment";
import DateInformation from "./Components/DateInformation";
import OperationalInformation from "./Components/OperationalInformation";
import { gonderilecekMesaiSatirlari } from "./Components/mesaiSatirlari";
import { gonderilecekHammaliyeSatirlari } from "./Components/hammaliyeSatirlari";
import FirmInformation from "./Components/FirmInformation";
import { GetCountryListResponse, GetCountryListResponseData } from "../../../models/response/country/GetCountryListResponse";
import { CountryService } from "../../../services/CountryService";
import LocationInformation from "./Components/LocationInformation";
import OrderDetails from "./Components/OrderDetails";
import AmbarExpectedIncomeOutcome from "./Components/AmbarExpectedIncomeOutcome";
import FileArchives from "./Components/FileArchives";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { CarryMethodEnum, CarryTypeEnum, OrderStatusAmbarEnum, ProjectEnum } from "../../../models/common/Enums";
import { ProjectRegionService } from "../../../services/ProjectRegionService";
import { GetProjectRegionListResponse } from "../../../models/response/projectRegion/GetProjectRegionListResponse";
import { GetAmbarVoyageListResponse, GetAmbarVoyageListResponseData } from "../../../models/response/ambarVoyage/GetAmbarVoyageListResponse";
import { AmbarVoyageService } from "../../../services/AmbarVoyageService";

const AmbarAdd = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Nakliye > Siparişler"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const generalInformationRef: any = useRef();
    const voyageInformationRef: any = useRef();
    const operationalInformationRef: any = useRef();
    const dateInformationRef: any = useRef();
    const firmInformationRef: any = useRef();
    const locationInformationRef: any = useRef();
    // const deliveryAndStatusRef: any = useRef();
    const productInformationRef: any = useRef();
    const expectedIncomeRef: any = useRef();
    const expectedOutcomeRef: any = useRef();
    const fileArchivesRef: any = useRef();

    const [ambarId, setAmbarId] = useState<string | undefined>(undefined);
    /** Aylık sabit gelir siparişi (08.10.2026): ekran sade açılır (Genel Bilgiler + Beklenen Gelir/Gider + Dijital Arşiv). */
    const [sabitGelir, setSabitGelir] = useState<{ tur?: number | null, yil?: number | null, ay?: number | null } | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedCustomer, setSelectedCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCarryType, setSelectedCarryType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedOrderStatus, setSelectedOrderStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCarryMethod, setSelectedCarryMethod] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [waitTime, setWaitTime] = useState<string | undefined>(undefined);
    const [warehouseReceipt, setWarehouseReceipt] = useState<string | undefined>(undefined);
    const [customerDeliveryNoteNumber, setCustomerDeliveryNoteNumber] = useState<string | undefined>(undefined);
    const [isBridge, setIsBridge] = useState<boolean>(false);
    const [isAdditionalLocation, setIsAdditionalLocation] = useState<boolean>(false);
    // Sefer guzergahi (15.10.2026): "Seferde ilk teslim (1. sira)"; yalniz sefere bagliyken gonderilir.
    const [elleIlkSira, setElleIlkSira] = useState<boolean>(false);
    const [isOvertimeTravelMeal, setIsOvertimeTravelMeal] = useState<boolean>(false);
    const [overtimePersonnels, setOvertimePersonnels] = useState<GetAmbarByIdResponseOvertimePersonnel[]>([]);
    const [isPorterage, setIsPorterage] = useState<boolean>(false);
    const [porteragePersonnels, setPorteragePersonnels] = useState<GetAmbarByIdResponsePorteragePersonnel[]>([]);
    const [selectedExpressVehicle, setSelectedExpressVehicle] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDivision, setSelectedDivision] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPo, setSelectedPo] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [poNo, setPoNo] = useState<string | undefined>(undefined);
    const [note, setNote] = useState<string | undefined>(undefined);
    const [bilgilendirmeMailleri, setBilgilendirmeMailleri] = useState<string | undefined>(undefined);

    const [ambarVoyageId, setAmbarVoyageId] = useState<string | undefined>(undefined);
    const [voyageRefNo, setVoyageRefNo] = useState<string | undefined>(undefined);
    const [selectedVehicle, setSelectedVehicle] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedTrailer, setSelectedTrailer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDriver, setSelectedDriver] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSupplier, setSelectedSupplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [voyageIsCustomActive, setVoyageIsCustomActive] = useState<boolean>(true);
    /** Kayitli sefer bitti mi (Sefere Bagla / Seferden Coz gizlenir) ve aracin takip cihazi var mi (Arac Takip gorunur). */
    const [voyageEnded, setVoyageEnded] = useState<boolean>(false);
    const [voyageHasTrackingDevice, setVoyageHasTrackingDevice] = useState<boolean>(false);
    const [selectedPricingVehicleType, setSelectedPricingVehicleType] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [orderDate, setOrderDate] = useState<string | undefined>(moment(new Date()).format("YYYY-MM-DDTHH:mm"));
    const [loadDate, setLoadDate] = useState<string | undefined>(undefined);
    const [deliveryDate, setDeliveryDate] = useState<string | undefined>(undefined);

    const [selectedSenderCustomer, setSelectedSenderCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSenderCustomerAddressType, setSelectedSenderCustomerAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [senderCustomerAddressText, setSenderCustomerAddressText] = useState<string | undefined>(undefined);

    const [selectedReceiverCustomer, setSelectedReceiverCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedReceiverCustomerAddressType, setSelectedReceiverCustomerAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [receiverCustomerAddressText, setReceiverCustomerAddressText] = useState<string | undefined>(undefined);

    const [selectedLoadingFirmCustomer, setSelectedLoadingFirmCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedLoadingFirmCustomerAddressType, setSelectedLoadingFirmCustomerAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [loadingFirmCustomerAddressText, setLoadingFirmCustomerAddressText] = useState<string | undefined>(undefined);

    const [selectedDeliverFirmCustomer, setSelectedDeliverFirmCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeliverFirmCustomerAddressType, setSelectedDeliverFirmCustomerAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [deliverFirmCustomerAddressText, setDeliverFirmCustomerAddressText] = useState<string | undefined>(undefined);

    const [trCountry, setTrCountry] = useState<GetCountryListResponseData | undefined>(undefined);
    const [trCurrency, setTrCurrency] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedLoadingCounty, setSelectedLoadingCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedLoadingDistrict, setSelectedLoadingDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedLoadingNeighborhood, setSelectedLoadingNeighborhood] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeliverCounty, setSelectedDeliverCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeliverDistrict, setSelectedDeliverDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeliverNeighborhood, setSelectedDeliverNeighborhood] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedLoadingRegion, setSelectedLoadingRegion] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDeliverRegion, setSelectedDeliverRegion] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [selectedShippingStatus, setSelectedShippingStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [shippingCreateDate, setShippingCreateDate] = useState<string | undefined>(undefined);
    const [shippingLoadDate, setShippingLoadDate] = useState<string | undefined>(undefined);
    const [shippingDeliverDate, setShippingDeliverDate] = useState<string | undefined>(undefined);
    const [shippingDeliverer, setShippingDeliverer] = useState<string | undefined>(undefined);
    const [shippingReceiver, setShippingReceiver] = useState<string | undefined>(undefined);

    const [ambarProducts, setAmbarProducts] = useState<GetAmbarByIdResponseAmbarProduct[]>([]);

    const [expectedIncomes, setExpectedIncomes] = useState<GetAmbarByIdResponseAmbarExpectedIncomeOutcome[]>([]);
    const [expectedOutcomes, setExpectedOutcomes] = useState<GetAmbarByIdResponseAmbarExpectedIncomeOutcome[]>([]);

    const [fileArchives, setFileArchives] = useState<GetAmbarByIdResponseFileArchive[]>([]);

    const [ambarVoyageList, setAmbarVoyageList] = useState<GetAmbarVoyageListResponseData[]>([]);

    /**
     * Ekran acildigindaki kayit surumu (#424). Kaydet bunu gonderir; ekran acildiktan sonra siparis
     * baska yerden (irsaliye, teslim, mobil, Fiyat Bul, fatura) degistiyse sunucu kaydi reddeder.
     * Kopyalama/yeni kayitta bos kalir.
     */
    const kayitSurumu = useRef<string | null | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");

        if (!id) {
            var copyid = searchParams.get("copyid");

            if (copyid) {
                getData(copyid, true);
                return;
            }
        }

        getData(id);
    }, [])

    // Kayıt okunurken bölge alanları yeniden hesaplanmaz; kayıtta duran bölge korunur.
    const kayitYukleniyor = useRef(false);

    /**
     * Başlangıç ve bitiş bölgesini Proje - Bölge Eşleştirme tanımlarından bulur.
     * Proje her zaman Nakliye (AMBAR); ayrıca taşıma yöntemi ile il, ilçe ve semte
     * bakılır. Semt düzeyinde tanım yoksa backend ilçe düzeyindeki tanıma düşer.
     */
    const bolgeBul = async (
        _county: CustomSingleSelectModel | undefined,
        _district: CustomSingleSelectModel | undefined,
        _neighborhood: CustomSingleSelectModel | undefined,
        _bolgeyiAta: (_bolge: CustomSingleSelectModel | undefined) => void
    ) => {
        if (!_county && !_district && !_neighborhood) {
            _bolgeyiAta(undefined);
            return;
        }

        try {
            var response: GetProjectRegionListResponse = await ProjectRegionService.getProjectRegionList(
                _county,
                _district,
                _neighborhood,
                selectedCarryType ? [selectedCarryType] : undefined,
                { label: '', value: '', additionalValue1: ProjectEnum.AMBAR });

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            _bolgeyiAta(response.data.length > 0
                ? { label: response.data[0].regionName, value: response.data[0].regionId }
                : undefined);
        } catch (error: any) {
            toast.error(error)
        }
    }

    // Yükleme tarafı: taşıma yöntemi ya da il/ilçe/semt değişince başlangıç bölgesi yenilenir.
    // Bu alanlar hem firma seçilince hem de elle değiştirilince güncellendiği için
    // iki yol da aynı tetiklemeye düşer.
    useEffect(() => {
        if (kayitYukleniyor.current)
            return;

        bolgeBul(selectedLoadingCounty, selectedLoadingDistrict, selectedLoadingNeighborhood, setSelectedLoadingRegion);
    }, [selectedCarryType, selectedLoadingCounty, selectedLoadingDistrict, selectedLoadingNeighborhood])

    // Teslim tarafı: bitiş bölgesi.
    useEffect(() => {
        if (kayitYukleniyor.current)
            return;

        bolgeBul(selectedDeliverCounty, selectedDeliverDistrict, selectedDeliverNeighborhood, setSelectedDeliverRegion);
    }, [selectedCarryType, selectedDeliverCounty, selectedDeliverDistrict, selectedDeliverNeighborhood])

    const getData = async (_id: string | undefined | null = undefined, _isCopy: boolean = false) => {
        try {
            kayitYukleniyor.current = true;

            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            var response2: GetCountryListResponse = await CountryService.getCountryList('TR');

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            setTrCountry(response2.data.length > 0 ? response2.data[0] : undefined)

            var responseTrCurrency: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY', undefined, 'TRY');

            if (!responseTrCurrency.isSuccess) {
                toast.error(responseTrCurrency.message)
                return;
            }

            setTrCurrency({ label: responseTrCurrency.data[0].value, value: responseTrCurrency.data[0].constantId, additionalValue1: responseTrCurrency.data[0].additionalValue1 });

            if (id) {
                var response: GetAmbarByIdResponse = await AmbarService.getAmbarById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setSabitGelir(!_isCopy && response.data.siparisTuru === 2
                    ? { tur: response.data.sabitGelirTuru, yil: response.data.donemYil, ay: response.data.donemAy }
                    : undefined);

                setAmbarId(_isCopy ? undefined : response.data.ambarId);
                kayitSurumu.current = _isCopy ? undefined : (response.data.kayitSurumu ?? null);
                setRefNo(_isCopy ? undefined : response.data.refNo);

                setSelectedCustomer(response.data.customerId && response.data.customerName ? { label: response.data.customerName, value: response.data.customerId } : undefined);

                setSelectedCarryType(response.data.carryTypeId && response.data.carryTypeName ? { label: response.data.carryTypeName, value: response.data.carryTypeId, additionalValue1: response.data.carryTypeKey } : undefined);

                setSelectedOrderStatus(response.data.orderStatusId && response.data.orderStatusName ? { label: response.data.orderStatusName, value: response.data.orderStatusId } : undefined);

                setSelectedCarryMethod(response.data.carryMethodId && response.data.carryMethodName ? { label: response.data.carryMethodName, value: response.data.carryMethodId } : undefined);

                setWaitTime(response.data.waitTime?.toString())
                setWarehouseReceipt(response.data.warehouseReceipt);
                setCustomerDeliveryNoteNumber(response.data.customerDeliveryNoteNumber);
                setIsBridge(response.data.isBridge);
                setIsAdditionalLocation(response.data.isAdditionalLocation);
                setElleIlkSira(!!response.data.elleIlkSira);
                setIsOvertimeTravelMeal(response.data.isOvertimeTravelMeal);
                setOvertimePersonnels(response.data.ambarOvertimePersonnels ?? []);
                setIsPorterage(response.data.isPorterage ?? false);
                setPorteragePersonnels(response.data.ambarPorteragePersonnels ?? []);

                setSelectedExpressVehicle(response.data.expressVehicleId && response.data.expressVehicleName ? { label: response.data.expressVehicleName, value: response.data.expressVehicleId } : undefined);

                setSelectedDivision(response.data.divisionId && response.data.divisionName ? { label: response.data.divisionName, value: response.data.divisionId } : undefined);

                setSelectedPo(response.data.poId && response.data.poName ? { label: response.data.poName, value: response.data.poId } : undefined);

                setPoNo(response.data.poNo);
                setNote(response.data.note);
                setBilgilendirmeMailleri(response.data.bilgilendirmeMailleri ?? undefined);

                if (!_isCopy) {
                    setAmbarVoyageId(response.data.ambarVoyage?.ambarVoyageId);
                    setVoyageRefNo(response.data.ambarVoyage?.refNo);

                    setSelectedVehicle(response.data.ambarVoyage?.vehicleId && response.data.ambarVoyage?.vehicleName ? { label: response.data.ambarVoyage?.vehicleName, value: response.data.ambarVoyage?.vehicleId } : undefined);

                    setSelectedTrailer(response.data.ambarVoyage?.trailerId && response.data.ambarVoyage?.trailerName ? { label: response.data.ambarVoyage?.trailerName, value: response.data.ambarVoyage?.trailerId } : undefined);

                    setSelectedDriver(response.data.ambarVoyage?.driverId && response.data.ambarVoyage?.driverName ? { label: response.data.ambarVoyage?.driverName, value: response.data.ambarVoyage?.driverId } : undefined);

                    setSelectedSupplier(response.data.ambarVoyage?.supplierId && response.data.ambarVoyage?.supplierName ? { label: response.data.ambarVoyage?.supplierName, value: response.data.ambarVoyage?.supplierId } : undefined);

                    if (response?.data?.ambarVoyage) {
                        setVoyageIsCustomActive(response.data.ambarVoyage.isCustomActive);
                        setVoyageEnded(!!response.data.ambarVoyage.endDate);
                        setVoyageHasTrackingDevice(!!response.data.ambarVoyage.hasTrackingDevice);
                    }
                    else {
                        // "Sayfayi yenile" (#424): sefer baska yerden cozulduyse eski seferin bayraklari kalmasin.
                        setVoyageIsCustomActive(true);
                        setVoyageEnded(false);
                        setVoyageHasTrackingDevice(false);
                    }

                    setSelectedPricingVehicleType(response.data.ambarVoyage?.pricingVehicleTypeId && response.data.ambarVoyage?.pricingVehicleTypeName ? { label: response.data.ambarVoyage.pricingVehicleTypeName, value: response.data.ambarVoyage.pricingVehicleTypeId } : undefined);
                }

                if (!_isCopy) {
                    setOrderDate(response.data.orderDate);
                    setLoadDate(response.data.loadDate);
                    setDeliveryDate(response.data.deliveryDate);
                }

                setSelectedSenderCustomer(response.data.senderCustomerId && response.data.senderCustomerName ? { label: response.data.senderCustomerName, value: response.data.senderCustomerId } : undefined);

                setSelectedSenderCustomerAddressType(response.data.senderCustomerAddressTypeId && response.data.senderCustomerAddressTypeName ? { label: response.data.senderCustomerAddressTypeName, value: response.data.senderCustomerAddressTypeId } : undefined);

                setSenderCustomerAddressText(response.data.senderCustomerAddressText);

                setSelectedReceiverCustomer(response.data.receiverCustomerId && response.data.receiverCustomerName ? { label: response.data.receiverCustomerName, value: response.data.receiverCustomerId } : undefined);

                setSelectedReceiverCustomerAddressType(response.data.receiverCustomerAddressTypeId && response.data.receiverCustomerAddressTypeName ? { label: response.data.receiverCustomerAddressTypeName, value: response.data.receiverCustomerAddressTypeId } : undefined);

                setReceiverCustomerAddressText(response.data.receiverCustomerAddressText);

                setSelectedLoadingFirmCustomer(response.data.loadingFirmCustomerId && response.data.loadingFirmCustomerName ? { label: response.data.loadingFirmCustomerName, value: response.data.loadingFirmCustomerId } : undefined);

                setSelectedLoadingFirmCustomerAddressType(response.data.loadingFirmCustomerAddressTypeId && response.data.loadingFirmCustomerAddressTypeName ? { label: response.data.loadingFirmCustomerAddressTypeName, value: response.data.loadingFirmCustomerAddressTypeId } : undefined);

                setLoadingFirmCustomerAddressText(response.data.loadingFirmCustomerAddressText);

                setSelectedDeliverFirmCustomer(response.data.deliverFirmCustomerId && response.data.deliverFirmCustomerName ? { label: response.data.deliverFirmCustomerName, value: response.data.deliverFirmCustomerId } : undefined);

                setSelectedDeliverFirmCustomerAddressType(response.data.deliverFirmCustomerAddressTypeId && response.data.deliverFirmCustomerAddressTypeName ? { label: response.data.deliverFirmCustomerAddressTypeName, value: response.data.deliverFirmCustomerAddressTypeId } : undefined);

                setDeliverFirmCustomerAddressText(response.data.deliverFirmCustomerAddressText);

                setSelectedLoadingCounty(response.data.loadingCountyId && response.data.loadingCountyName ? { label: response.data.loadingCountyName, value: response.data.loadingCountyId } : undefined);

                setSelectedLoadingDistrict(response.data.loadingDistrictId && response.data.loadingDistrictName ? { label: response.data.loadingDistrictName, value: response.data.loadingDistrictId } : undefined);

                setSelectedLoadingNeighborhood(response.data.loadingNeighborhoodId && response.data.loadingNeighborhoodName ? { label: response.data.loadingNeighborhoodName, value: response.data.loadingNeighborhoodId } : undefined);

                setSelectedDeliverCounty(response.data.deliverCountyId && response.data.deliverCountyName ? { label: response.data.deliverCountyName, value: response.data.deliverCountyId } : undefined);

                setSelectedDeliverDistrict(response.data.deliverDistrictId && response.data.deliverDistrictName ? { label: response.data.deliverDistrictName, value: response.data.deliverDistrictId } : undefined);

                setSelectedDeliverNeighborhood(response.data.deliverNeighborhoodId && response.data.deliverNeighborhoodName ? { label: response.data.deliverNeighborhoodName, value: response.data.deliverNeighborhoodId } : undefined);

                setSelectedDeliverRegion(response.data.deliverRegionId && response.data.deliverRegionName ? { label: response.data.deliverRegionName, value: response.data.deliverRegionId } : undefined);

                setSelectedLoadingRegion(response.data.loadingRegionId && response.data.loadingRegionName ? { label: response.data.loadingRegionName, value: response.data.loadingRegionId } : undefined);

                setSelectedShippingStatus(response.data.shippingStatusId && response.data.shippingStatusName ? { label: response.data.shippingStatusName, value: response.data.shippingStatusId } : undefined);

                setShippingCreateDate(response.data.shippingCreateDate);
                setShippingLoadDate(response.data.shippingLoadDate);
                setShippingDeliverDate(response.data.shippingDeliverDate);
                setShippingDeliverer(response.data.shippingDeliverer);
                setShippingReceiver(response.data.shippingReceiver);

                setAmbarProducts(response.data.ambarProducts);

                setExpectedIncomes(response.data.ambarExpectedIncomeOutcomes.filter(x => x.isIncome));
                setExpectedOutcomes(response.data.ambarExpectedIncomeOutcomes.filter(x => !x.isIncome));

                setFileArchives(response.data.fileArchives);
            }
            else {
                kayitSurumu.current = undefined;

                var response3: GetConstantListResponse = await ConstantService.getConstantList('ORDER_STATUS_AMBAR', undefined, OrderStatusAmbarEnum.OLUSTURULDU);

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                setSelectedOrderStatus({ label: response3.data[0].value, value: response3.data[0].constantId });

                var response3: GetConstantListResponse = await ConstantService.getConstantList('CARRY_TYPE', undefined, CarryTypeEnum.GENEL);

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                setSelectedCarryType({ label: response3.data[0].value, value: response3.data[0].constantId });

                var response3: GetConstantListResponse = await ConstantService.getConstantList('CARRY_METHOD', undefined, CarryMethodEnum.NORMAL);

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                setSelectedCarryMethod({ label: response3.data[0].value, value: response3.data[0].constantId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Bayrak, kayıttan gelen alanların yerleşmesi bittikten sonra kalkar;
            // böylece okuma sırasındaki değişiklikler bölgeyi yeniden hesaplatmaz.
            setTimeout(() => { kayitYukleniyor.current = false }, 0);

            dispatch(storeActivityIndicator(false))
        }
    }

    /**
     * _stayOnScreen: detay kaydedildiginde kullanilir; kayittan sonra ekrandan
     * cikilmaz, kayit sunucudan yeniden yuklenir.
     * _products: detay listesi yeni degeriyle gonderilir (React durumu henuz
     * guncellenmemis olabilir).
     */
    const saveAmbarPre = (_stayOnScreen: boolean = false, _products: GetAmbarByIdResponseAmbarProduct[] | undefined = undefined) => {
        const gecersizAdresler = gecersizMailler(bilgilendirmeMailleri);

        if (Helpers.isEmpty(orderDate))
            toast.error('Sipariş Tarihi alanını doldurunuz!')
        else if (gecersizAdresler.length > 0)
            toast.error('Bilgilendirme Mailleri alanında geçersiz e-posta adresi var: ' + gecersizAdresler.join(', '))
        else if (!ambarVoyageId && selectedVehicle) {
            dispatch(storeEbbeModalCallback({
                title: 'Bilgilendirme',
                body: 'Yükünüz İçin yeni bir sefer oluşturulmaktadır. Devam etmek ister misiniz? Yoksa başka bir sefere mi bağlamak istersiniz?',
                buttons: [
                    {
                        text: 'Vazgeç',
                        btnClass: 'btn-warning',
                    },
                    {
                        text: 'Başka Sefere Bağla',
                        btnClass: 'btn-danger',
                        onClick: () => {
                            setTimeout(connectVoyage, 500)
                        }
                    },
                    {
                        text: 'Yeni Seferle Devam Et',
                        btnClass: 'btn-success',
                        onClick: () => saveAmbar(_stayOnScreen, _products)
                    }
                ]
            }))
        }
        else
            saveAmbar(_stayOnScreen, _products);
    }

    const connectVoyage = async () => {
        try {
            var headerOffset = 120;
            var elementPosition = voyageInformationRef.current.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });

            dispatch(storeActivityIndicator(true));

            var response2: GetAmbarVoyageListResponse = await AmbarVoyageService.getAmbarVoyageList(true);

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            if (response2.data.length == 0) {
                toast.error('Aktif sefer bulunamadı.');
                return;
            }

            setAmbarVoyageList(response2.data);
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    // Aylık sabit gelir: faturalanmamış satırlar güncel anlaşma ve oranlarla yeniden yazılır.
    const sabitGelirSatirlariniYenile = async () => {
        if (!ambarId) return;

        try {
            dispatch(storeActivityIndicator(true));
            const r = await SabitGelirService.siparisYenile(ambarId);

            if (!r.isSuccess) {
                toast.error(r.message ?? '');
                return;
            }

            toast.success('Satırlar güncel anlaşma ve oranlarla yeniden yazıldı.');
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }

        await getData(ambarId);
    }

    /**
     * Ekran icinden sunucuya yazan bir islemden sonra (or. Fiyat Bul Kaydet) saklanan surum tazelenir;
     * yoksa kullanicinin kendi islemi sonraki Kaydet'i "baskasi degistirdi" diye engeller (#424).
     */
    const kayitSurumuTazele = async () => {
        if (!ambarId)
            return;

        try {
            var r = await AmbarService.getKayitSurumu(ambarId);

            if (!r.isSuccess) {
                toast.error(r.message ?? '');
                return;
            }

            kayitSurumu.current = r.data ?? null;
        } catch (error: any) {
            toast.error(error);
        }
    }

    /** Ekran eskiyken Kaydet yapildi (#424): kayit yapilmadi; girilen degerler ekranda kalir, yenile en guncel hali yukler. */
    const kayitDegistiUyarisi = (_mesaj: string | undefined) => {
        dispatch(storeEbbeModalCallback({
            title: 'Uyarı',
            body: !Helpers.isEmpty(_mesaj)
                ? _mesaj + ''
                : 'Bu sipariş siz ekranı açtıktan sonra başka yerden değiştirildi. Kaydınız yapılmadı; sayfayı yenileyip tekrar deneyin.',
            buttons: [
                {
                    text: 'Vazgeç',
                    btnClass: 'btn-warning',
                },
                {
                    text: 'Sayfayı Yenile',
                    btnClass: 'btn-success',
                    onClick: () => getData(ambarId)
                }
            ]
        }))
    }

    /** Seferde baska siparis ilk teslimdeyse: onaylanirsa isaret bu siparise tasinarak yeniden kaydedilir. */
    const ilkSiraCakismaOnayi = (_mesaj: string | undefined, _stayOnScreen: boolean, _products: GetAmbarByIdResponseAmbarProduct[] | undefined) => {
        dispatch(storeEbbeModalCallback({
            title: 'İlk Teslim',
            body: !Helpers.isEmpty(_mesaj) ? _mesaj + '' : 'Bu seferde başka bir sipariş ilk teslim olarak işaretli. İlk teslim bu siparişe taşınsın mı?',
            buttons: [
                {
                    text: 'Vazgeç',
                    btnClass: 'btn-warning',
                },
                {
                    text: 'Evet, bu siparişe taşı',
                    btnClass: 'btn-success',
                    onClick: () => saveAmbar(_stayOnScreen, _products, true)
                }
            ]
        }))
    }

    const saveAmbar = async (_stayOnScreen: boolean = false, _products: GetAmbarByIdResponseAmbarProduct[] | undefined = undefined, _ilkSiraOnay: boolean = false) => {
        try {
            dispatch(storeActivityIndicator(true));

            var obj: AddAmbarRequest = {
                ambarId: ambarId,
                refNo: refNo,
                carryMethodId: selectedCarryMethod?.value,
                carryTypeId: selectedCarryType?.value,
                orderStatusId: selectedOrderStatus?.value,
                customerDeliveryNoteNumber: customerDeliveryNoteNumber,
                customerId: selectedCustomer?.value,
                divisionId: selectedDivision?.value,
                expressVehicleId: selectedExpressVehicle?.value,
                isBridge: isBridge,
                isAdditionalLocation: isAdditionalLocation,
                // Sefere bagli degilse gonderilmez (sunucu isarete dokunmaz).
                elleIlkSira: (ambarVoyageId || voyageRefNo) ? elleIlkSira : undefined,
                elleIlkSiraOnay: _ilkSiraOnay,
                isOvertimeTravelMeal: isOvertimeTravelMeal,
                ambarOvertimePersonnels: gonderilecekMesaiSatirlari(isOvertimeTravelMeal, overtimePersonnels),
                isPorterage: isPorterage,
                ambarPorteragePersonnels: gonderilecekHammaliyeSatirlari(isPorterage, porteragePersonnels),
                note: note,
                bilgilendirmeMailleri: mailListesiDuzenle(bilgilendirmeMailleri) || undefined,
                poId: selectedPo?.value,
                poNo: poNo,
                waitTime: waitTime,
                warehouseReceipt: warehouseReceipt,
                ambarVoyageId: ambarVoyageId,
                voyageRefNo: voyageRefNo,
                driverId: selectedDriver?.value,
                supplierId: selectedSupplier?.value,
                trailerId: selectedTrailer?.value,
                vehicleId: selectedVehicle?.value,
                pricingVehicleTypeId: selectedPricingVehicleType?.value,
                orderDate: orderDate,
                loadDate: loadDate,
                deliveryDate: deliveryDate,
                senderCustomerId: selectedSenderCustomer?.value,
                senderCustomerAddressTypeId: selectedSenderCustomerAddressType?.value,
                senderCustomerAddressText: senderCustomerAddressText,
                receiverCustomerId: selectedReceiverCustomer?.value,
                receiverCustomerAddressTypeId: selectedReceiverCustomerAddressType?.value,
                receiverCustomerAddressText: receiverCustomerAddressText,
                loadingFirmCustomerId: selectedLoadingFirmCustomer?.value,
                loadingFirmCustomerAddressTypeId: selectedLoadingFirmCustomerAddressType?.value,
                loadingFirmCustomerAddressText: loadingFirmCustomerAddressText,
                deliverFirmCustomerId: selectedDeliverFirmCustomer?.value,
                deliverFirmCustomerAddressTypeId: selectedDeliverFirmCustomerAddressType?.value,
                deliverFirmCustomerAddressText: deliverFirmCustomerAddressText,
                deliverCountyId: selectedDeliverCounty?.value,
                deliverDistrictId: selectedDeliverDistrict?.value,
                deliverNeighborhoodId: selectedDeliverNeighborhood?.value,
                loadingCountyId: selectedLoadingCounty?.value,
                loadingDistrictId: selectedLoadingDistrict?.value,
                loadingNeighborhoodId: selectedLoadingNeighborhood?.value,
                deliverRegionId: selectedDeliverRegion?.value,
                loadingRegionId: selectedLoadingRegion?.value,
                shippingCreateDate: shippingCreateDate,
                shippingDeliverDate: shippingDeliverDate,
                shippingDeliverer: shippingDeliverer,
                shippingLoadDate: shippingLoadDate,
                shippingReceiver: shippingReceiver,
                shippingStatusId: selectedShippingStatus?.value,
                ambarProducts: (_products ?? ambarProducts).map(function (x) {
                    return {
                        ambarProductId: x.ambarProductId.startsWith('newrecrd') ? undefined : x.ambarProductId,
                        desi: x.desi?.toString(),
                        detailVolumetricWeight: x.detailVolumetricWeight?.toString(),
                        potTypeId: x.potTypeId,
                        product: x.product,
                        quantity: x.quantity?.toString(),
                        weight: x.weight?.toString(),
                        height: x.height?.toString(),
                        length: x.length?.toString(),
                        width: x.width?.toString(),
                        description: x.description?.toString(),
                    }
                }),
                ambarExpectedIncomeOutcomes: [...expectedIncomes, ...expectedOutcomes].map(function (x) {
                    return {
                        ambarExpectedIncomeOutcomeId: x.ambarExpectedIncomeOutcomeId.startsWith('newrecrd') ? undefined : x.ambarExpectedIncomeOutcomeId,
                        currency: x.currency,
                        currencyTypeId: x.currencyTypeId,
                        description: x.description,
                        invoiceDate: x.invoiceDate,
                        invoiceNo: x.invoiceNo,
                        isApproved: x.isApproved ? 1 : 0,
                        isIncome: x.isIncome ? 1 : 0,
                        quantity: x.quantity?.toString(),
                        serviceId: x.serviceId,
                        taxPrice: x.taxPrice?.toString(),
                        totalPrice: x.totalPrice?.toString(),
                        totalWithoutTaxPrice: x.totalWithoutTaxPrice?.toString(),
                        unitPrice: x.unitPrice?.toString(),
                        taxRate: x.taxRate
                    }
                }),
                fileArchives: fileArchives.map(function (x) {
                    return {
                        description: x.description,
                        entityId: x.entityId,
                        file: x.fileArchiveFile,
                        fileName: x.fileName,
                        fileTypeId: x.fileTypeId,
                        fileArchiveId: x.fileArchiveId
                    }
                }),
            }

            // Yalniz mevcut siparis guncellenirken (#424); kopyalama/yeni kayitta alan hic gonderilmez.
            if (ambarId && kayitSurumu.current)
                obj.kayitSurumu = kayitSurumu.current;

            var response: AddAmbarResponse = await AmbarService.addAmbar(obj);

            if (!response.isSuccess) {
                dispatch(storeActivityIndicator(false));

                if (response.data?.kayitDegisti) {
                    kayitDegistiUyarisi(response.message);
                    return;
                }

                if (response.data?.ilkSiraCakisma) {
                    ilkSiraCakismaOnayi(response.message, _stayOnScreen, _products);
                    return;
                }

                toast.error(response.message);
                return;
            }

            if (response.data && response.data.kayitSurumu !== undefined)
                kayitSurumu.current = response.data.kayitSurumu;

            toast.success(response.message)

            // Toplama - Dagitim: ek lokasyonsuz siparis en uzak nokta degilse (kayit yapildi, yalniz uyari).
            if (response.data?.kayitUyarisi)
                toast(response.data.kayitUyarisi, { duration: 10000, icon: '⚠️' })

            if (_stayOnScreen) {
                await getData(response.data.ambarId);

                setTimeout(() => {
                    if (!productInformationRef.current)
                        return;

                    var headerOffset = 120;
                    var elementPosition = productInformationRef.current.getBoundingClientRect().top;

                    window.scrollTo({ top: elementPosition + window.pageYOffset - headerOffset, behavior: 'smooth' });
                }, 0);

                return;
            }

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={sabitGelir ? [
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Bek. Gelir', ref: expectedIncomeRef },
                            { text: 'Bek. Gider', ref: expectedOutcomeRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ] : [
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Sefer Bilgileri', ref: voyageInformationRef },
                            { text: 'Operasyonel Bilgiler', ref: operationalInformationRef },
                            { text: 'Tarih ve Teslimat Bilgileri', ref: dateInformationRef },
                            { text: 'Firma Bilgileri', ref: firmInformationRef },
                            { text: 'Lokasyon Bilgileri', ref: locationInformationRef },
                            // { text: 'Teslimat ve Durum', ref: deliveryAndStatusRef },
                            { text: 'Sipariş Detayları', ref: productInformationRef },
                            { text: 'Bek. Gelir', ref: expectedIncomeRef },
                            { text: 'Bek. Gider', ref: expectedOutcomeRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    {/* Sipariş türü gezinme çubuğunun altında, mat turuncu çerçeveli (09.10.2026). */}
                    {
                        !ambarId && (
                            <div className='mt-5'>
                                <SiparisTuruSecici secili={1} onChange={() => navigate('/ambar/sabitgelir')} />
                            </div>
                        )
                    }

                    <GeneralInformation
                        customerDeliveryNoteNumber={customerDeliveryNoteNumber}
                        generalInformationRef={generalInformationRef}
                        note={note}
                        poNo={poNo}
                        refNo={refNo}
                        selectedCarryMethod={selectedCarryMethod}
                        selectedCarryType={selectedCarryType}
                        selectedCustomer={selectedCustomer}
                        selectedDivision={selectedDivision}
                        selectedExpressVehicle={selectedExpressVehicle}
                        selectedPo={selectedPo}
                        setCustomerDeliveryNoteNumber={setCustomerDeliveryNoteNumber}
                        setNote={setNote}
                        bilgilendirmeMailleri={bilgilendirmeMailleri}
                        setBilgilendirmeMailleri={setBilgilendirmeMailleri}
                        setPoNo={setPoNo}
                        setRefNo={setRefNo}
                        setSelectedCarryMethod={setSelectedCarryMethod}
                        setSelectedCarryType={setSelectedCarryType}
                        setSelectedCustomer={setSelectedCustomer}
                        setSelectedDivision={setSelectedDivision}
                        setSelectedExpressVehicle={setSelectedExpressVehicle}
                        setSelectedPo={setSelectedPo}
                        setWarehouseReceipt={setWarehouseReceipt}
                        warehouseReceipt={warehouseReceipt}
                        selectedOrderStatus={selectedOrderStatus}
                        setSelectedOrderStatus={setSelectedOrderStatus}
                        orderDate={orderDate}
                        sabitGelir={!!sabitGelir}
                        setOrderDate={setOrderDate}
                        baslikEki={sabitGelir && (
                            <Box flexDirection="row" alignItems="center" flexGrow={1} ml="12px">
                                <span className="badge badge-light-primary me-2">Aylık Sabit Gelir</span>
                                <span className="badge badge-light me-2">{sabitGelirTurAdi(sabitGelir.tur)}</span>
                                <span className="badge badge-light">{donemAdi(sabitGelir.yil, sabitGelir.ay)}</span>
                                <Box flexGrow={1}>&nbsp;</Box>
                                <button type="button" className="btn btn-sm btn-light-primary" title="Faturalanmamış satırları güncel anlaşma ve oranlarla yeniden yazar" onClick={sabitGelirSatirlariniYenile}>Satırları yenile</button>
                            </Box>
                        )}
                    />

                    {!sabitGelir && (<React.Fragment>
                    <OperationalInformation
                        operationalInformationRef={operationalInformationRef}
                        waitTime={waitTime}
                        setWaitTime={setWaitTime}
                        isBridge={isBridge}
                        setIsBridge={setIsBridge}
                        isAdditionalLocation={isAdditionalLocation}
                        setIsAdditionalLocation={setIsAdditionalLocation}
                        isOvertimeTravelMeal={isOvertimeTravelMeal}
                        setIsOvertimeTravelMeal={setIsOvertimeTravelMeal}
                        overtimePersonnels={overtimePersonnels}
                        setOvertimePersonnels={setOvertimePersonnels}
                        isPorterage={isPorterage}
                        setIsPorterage={setIsPorterage}
                        porteragePersonnels={porteragePersonnels}
                        setPorteragePersonnels={setPorteragePersonnels}
                    />

                    <VoyageInformation
                        selectedDriver={selectedDriver}
                        selectedSupplier={selectedSupplier}
                        selectedTrailer={selectedTrailer}
                        selectedVehicle={selectedVehicle}
                        setSelectedDriver={setSelectedDriver}
                        setSelectedSupplier={setSelectedSupplier}
                        setSelectedTrailer={setSelectedTrailer}
                        setSelectedVehicle={setSelectedVehicle}
                        setVoyageRefNo={setVoyageRefNo}
                        voyageInformationRef={voyageInformationRef}
                        voyageRefNo={voyageRefNo}
                        ambarVoyageId={ambarVoyageId}
                        setAmbarVoyageId={setAmbarVoyageId}
                        elleIlkSira={elleIlkSira}
                        setElleIlkSira={setElleIlkSira}
                        setVoyageIsCustomActive={setVoyageIsCustomActive}
                        voyageIsCustomActive={voyageIsCustomActive}
                        voyageEnded={voyageEnded}
                        setVoyageEnded={setVoyageEnded}
                        voyageHasTrackingDevice={voyageHasTrackingDevice}
                        setVoyageHasTrackingDevice={setVoyageHasTrackingDevice}
                        selectedPricingVehicleType={selectedPricingVehicleType}
                        setSelectedPricingVehicleType={setSelectedPricingVehicleType}
                        ambarVoyageList={ambarVoyageList}
                        connectVoyage={connectVoyage}
                        setAmbarVoyageList={setAmbarVoyageList}
                        ambarId={ambarId}
                    />

                    <DateInformation
                        dateInformationRef={dateInformationRef}
                        deliveryDate={deliveryDate}
                        loadDate={loadDate}
                        orderDate={orderDate}
                        setDeliveryDate={setDeliveryDate}
                        setLoadDate={setLoadDate}
                        setOrderDate={setOrderDate}
                        selectedOrderStatus={selectedOrderStatus}
                        setSelectedOrderStatus={setSelectedOrderStatus}
                        setShippingDeliverer={setShippingDeliverer}
                        setShippingReceiver={setShippingReceiver}
                        shippingDeliverer={shippingDeliverer}
                        shippingReceiver={shippingReceiver}
                    />

                    <FirmInformation
                        firmInformationRef={firmInformationRef}
                        deliverFirmCustomerAddressText={deliverFirmCustomerAddressText}
                        loadingFirmCustomerAddressText={loadingFirmCustomerAddressText}
                        receiverCustomerAddressText={receiverCustomerAddressText}
                        selectedDeliverFirmCustomer={selectedDeliverFirmCustomer}
                        selectedDeliverFirmCustomerAddressType={selectedDeliverFirmCustomerAddressType}
                        selectedLoadingFirmCustomer={selectedLoadingFirmCustomer}
                        selectedLoadingFirmCustomerAddressType={selectedLoadingFirmCustomerAddressType}
                        selectedReceiverCustomer={selectedReceiverCustomer}
                        selectedReceiverCustomerAddressType={selectedReceiverCustomerAddressType}
                        selectedSenderCustomer={selectedSenderCustomer}
                        selectedSenderCustomerAddressType={selectedSenderCustomerAddressType}
                        senderCustomerAddressText={senderCustomerAddressText}
                        setDeliverFirmCustomerAddressText={setDeliverFirmCustomerAddressText}
                        setLoadingFirmCustomerAddressText={setLoadingFirmCustomerAddressText}
                        setReceiverCustomerAddressText={setReceiverCustomerAddressText}
                        setSelectedDeliverFirmCustomer={setSelectedDeliverFirmCustomer}
                        setSelectedDeliverFirmCustomerAddressType={setSelectedDeliverFirmCustomerAddressType}
                        setSelectedLoadingFirmCustomer={setSelectedLoadingFirmCustomer}
                        setSelectedLoadingFirmCustomerAddressType={setSelectedLoadingFirmCustomerAddressType}
                        setSelectedReceiverCustomer={setSelectedReceiverCustomer}
                        setSelectedReceiverCustomerAddressType={setSelectedReceiverCustomerAddressType}
                        setSelectedSenderCustomer={setSelectedSenderCustomer}
                        setSelectedSenderCustomerAddressType={setSelectedSenderCustomerAddressType}
                        setSenderCustomerAddressText={setSenderCustomerAddressText}
                        selectedLoadingCounty={selectedLoadingCounty}
                        selectedLoadingDistrict={selectedLoadingDistrict}
                        selectedLoadingNeighborhood={selectedLoadingNeighborhood}
                        setSelectedLoadingCounty={setSelectedLoadingCounty}
                        setSelectedLoadingDistrict={setSelectedLoadingDistrict}
                        setSelectedLoadingNeighborhood={setSelectedLoadingNeighborhood}
                        selectedDeliverCounty={selectedDeliverCounty}
                        selectedDeliverDistrict={selectedDeliverDistrict}
                        selectedDeliverNeighborhood={selectedDeliverNeighborhood}
                        setSelectedDeliverCounty={setSelectedDeliverCounty}
                        setSelectedDeliverDistrict={setSelectedDeliverDistrict}
                        setSelectedDeliverNeighborhood={setSelectedDeliverNeighborhood}
                        selectedDeliverRegion={selectedDeliverRegion}
                        selectedLoadingRegion={selectedLoadingRegion}
                        setSelectedDeliverRegion={setSelectedDeliverRegion}
                        setSelectedLoadingRegion={setSelectedLoadingRegion}
                        selectedCarryType={selectedCarryType}
                    />

                    <LocationInformation
                        locationInformationRef={locationInformationRef}
                        selectedDeliverCounty={selectedDeliverCounty}
                        selectedDeliverDistrict={selectedDeliverDistrict}
                        selectedDeliverNeighborhood={selectedDeliverNeighborhood}
                        selectedDeliverRegion={selectedDeliverRegion}
                        selectedLoadingCounty={selectedLoadingCounty}
                        selectedLoadingDistrict={selectedLoadingDistrict}
                        selectedLoadingNeighborhood={selectedLoadingNeighborhood}
                        selectedLoadingRegion={selectedLoadingRegion}
                        setSelectedDeliverCounty={setSelectedDeliverCounty}
                        setSelectedDeliverDistrict={setSelectedDeliverDistrict}
                        setSelectedDeliverNeighborhood={setSelectedDeliverNeighborhood}
                        setSelectedDeliverRegion={setSelectedDeliverRegion}
                        setSelectedLoadingCounty={setSelectedLoadingCounty}
                        setSelectedLoadingDistrict={setSelectedLoadingDistrict}
                        setSelectedLoadingNeighborhood={setSelectedLoadingNeighborhood}
                        setSelectedLoadingRegion={setSelectedLoadingRegion}
                        trCountry={trCountry}
                        selectedCarryType={selectedCarryType}
                    />

                    {/* <DeliveryAndStatus
                        deliveryAndStatusRef={deliveryAndStatusRef}
                        selectedShippingStatus={selectedShippingStatus}
                        setSelectedShippingStatus={setSelectedShippingStatus}
                        setShippingCreateDate={setShippingCreateDate}
                        setShippingDeliverDate={setShippingDeliverDate}
                        setShippingDeliverer={setShippingDeliverer}
                        setShippingLoadDate={setShippingLoadDate}
                        setShippingReceiver={setShippingReceiver}
                        shippingCreateDate={shippingCreateDate}
                        shippingDeliverDate={shippingDeliverDate}
                        shippingDeliverer={shippingDeliverer}
                        shippingLoadDate={shippingLoadDate}
                        shippingReceiver={shippingReceiver}
                    /> */}

                    <OrderDetails
                        ambarProducts={ambarProducts}
                        productInformationRef={productInformationRef}
                        setAmbarProducts={setAmbarProducts}
                        onDetailsSaved={(_products) => saveAmbarPre(true, _products)}
                    />
                    </React.Fragment>)}

                    {
                        trCurrency && (
                            <React.Fragment>
                                <AmbarExpectedIncomeOutcome
                                    expectedIncomeRef={expectedIncomeRef}
                                    expectedIncomes={expectedIncomes}
                                    isIncome={true}
                                    setExpectedIncomes={setExpectedIncomes}
                                    trCurrency={trCurrency}
                                    selectedPo={selectedPo}
                                    ambarId={ambarId}
                                    onSunucuyaYazildi={kayitSurumuTazele}
                                />

                                <AmbarExpectedIncomeOutcome
                                    expectedIncomeRef={expectedOutcomeRef}
                                    expectedIncomes={expectedOutcomes}
                                    isIncome={false}
                                    setExpectedIncomes={setExpectedOutcomes}
                                    trCurrency={trCurrency}
                                    selectedPo={selectedPo}
                                    ambarId={ambarId}
                                    onSunucuyaYazildi={kayitSurumuTazele}
                                />
                            </React.Fragment>
                        )
                    }

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={() => saveAmbarPre()}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default AmbarAdd;